// ColorSwatch.tsx
import React, { FunctionComponent } from "react";
import styled from "styled-components";
import Colors from "../global/Colors";
import Fonts from "../global/Fonts";
import { ColorMode } from "./ColorPicker";

const ColorSwatchRoot = styled.div<{ onClick?: (event: React.MouseEvent<HTMLElement>) => void }>`
  display: flex;
  align-items: center;
  gap: 8px;
  padding: 2px;
  border-radius: 4px;
  ${({ onClick }) => onClick && `cursor: pointer;`}
`;

const ColorRectangle = styled.div<{ size: number, color: string }>`
  width: ${({ size }) => `${size}px`};
  height: ${({ size }) => `${size}px`};
  background-color: ${({ color }) => color};
  border-radius: 2px;
  border: 1px solid ${Colors.grey5};
  flex-shrink: 0;
`;

const ColorLabel = styled.div<{ size: number; colorMode: ColorMode }>`
  font-family: ${Fonts.lexendLight.fontFamily};
  font-weight: ${Fonts.lexendLight.fontWeight};
  font-size: ${({ size }) => `${size * 0.7}px`};
  color: ${({ colorMode }) => (colorMode === "dark" ? Colors.white : Colors.grey9)};
  user-select: none;
  white-space: nowrap;
`;

export type ColorSwatchProps = {
  color: string;
  label?: string;
  size?: number;
  onClick?: (event: React.MouseEvent<HTMLElement>) => void;
  colorMode?: ColorMode;
};

const ColorSwatch: FunctionComponent<ColorSwatchProps> = ({
  color,
  label,
  size = 18,
  onClick,
  colorMode = "dark",
}) => {
  return (
    <ColorSwatchRoot onClick={onClick}>
      <ColorRectangle color={color} size={size} />
      {label && (
        <ColorLabel size={size} colorMode={colorMode}>
          {label.toUpperCase()}
        </ColorLabel>
      )}
    </ColorSwatchRoot>
  );
};

export default ColorSwatch;